import { ApolloClient, HttpLink, split } from '@apollo/client'
import { getMainDefinition } from '@apollo/client/utilities'
import { onError } from '@apollo/link-error'
import { WebSocketLink } from '@apollo/link-ws'
import { apiUrl } from 'config/constants'
import { isDynamicOrganizationDomain } from 'config/constants/urls'
import uuidv4 from 'src/components/utils/uuidv4'
import apiFetch from 'src/libraries/services/apiFetch'
import apolloCache from 'src/libraries/services/apolloCache'

let clientId = window?.sessionStorage?.getItem('gather-cid')
if (!clientId) {
   clientId = uuidv4()
   try {
      window.sessionStorage.setItem('gather-cid', clientId)
   } catch (err) {} // eslint-disable-line no-empty
}

const dynamicOrganizationId = isDynamicOrganizationDomain
   ? window.sessionStorage.getItem('ORGANIZATION_ID') || process.env.ORGANIZATION_ID
   : null

const wsLink = new WebSocketLink({
   uri: `${window.location.origin.replace('http', 'ws')}${apiUrl}/subscriptions`,
   options: {
      // TODO: Hack extraordinare - currently a source of insane traffic
      // See: https://github.com/mother/api/issues/787
      reconnect: !window.location.origin.includes('gns3.com'),
      connectionParams: {
         clientId,
         organizationId: dynamicOrganizationId
      }
   }
})

const httpLink = new HttpLink({
   fetch: apiFetch,
   headers: {
      'x-gather-cid': clientId
   },
   // No need to prefix this with api base uri because
   // that's already done within apiFetch
   uri: '/graphql'
})

// Use wsLink if operation type is a subscription
const chooseLink = ({ query }) => {
   const { kind, operation, name } = getMainDefinition(query)
   const { value: queryName } = name
   if (queryName.includes('Note')) return true
   return kind === 'OperationDefinition' && operation === 'subscription'
}

const apiLink = split(chooseLink, wsLink, httpLink)

// Basic error link for debugging in dev env
const errorLink = onError(({ networkError, graphQLErrors }) => {
   if (process.env.NODE_ENV === 'development') {
      if (networkError) {
         // eslint-disable-next-line no-console
         console.log('[GraphQL Network Error]', networkError)
      }
      if (graphQLErrors) {
         graphQLErrors.forEach((err) => {
            // eslint-disable-next-line no-console
            console.log('[GraphQL Error]', err)
         })
      }
   }
})

const apolloClient = new ApolloClient({
   cache: apolloCache,
   defaultOptions: {
      query: { fetchPolicy: 'cache-and-network' },
      watchQuery: { fetchPolicy: 'cache-and-network' }
   },
   link: errorLink.concat(apiLink)
})

export default apolloClient
